<template>
  <BaseModal
    small
    :heading="$t('marketing.email.save-template-modal.heading')"
    @close="$emit('close')"
    useForm
    @submit="onSubmit"
  >
    <Flex direction="column">
      <BaseAlert
        v-if="hasDeliverySchedule"
        color="warning"
        :text="`${$t('marketing.email.save-template-modal.scheduled_on')} ${filters.date(deliverAt)}`"
        v-test="'saveWarningAlert'"
      />

      <BaseInput
        v-model="name"
        :label="$t('global.name')"
        required
        v-test="'templateName'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        :disabled="isSaving"
        @click="$emit('close')"
        v-test="'saveTemplateCancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isSaving"
        submitForm
        v-test="'saveButton'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import eventBus from '@/event-bus';
import filters from '@/filters';
import { flash } from '@/helpers/ui';
import { useOnboardingStore } from '@/stores/onboarding';
import { useMarketingStore } from '../store';

export default defineComponent({
  emits: ['close'],
  setup() {
    const { currentOnboardingFlow } = storeToRefs(useOnboardingStore());
    const { name, hasDeliverySchedule, deliverAt } = storeToRefs(
      useMarketingStore(),
    );
    const { updateEmailTemplate, createEmailTemplate } = useMarketingStore();
    return {
      filters,
      currentOnboardingFlow,
      name,
      hasDeliverySchedule,
      deliverAt,
      updateEmailTemplate,
      createEmailTemplate,
    };
  },
  data() {
    return {
      isSaving: false,
    };
  },
  methods: {
    saveTemplate() {
      this.$router.push({ name: 'marketing-email' });
      if (this.currentOnboardingFlow === 'marketing') {
        eventBus.$emit('open-task-menu');
        this.currentOnboardingFlow = '';
      }
      flash(this.$t('global.flash.template_saved'));
    },
    onSubmit() {
      this.isSaving = true;

      if (this.$route.params.id) {
        this.updateEmailTemplate('MARKETING_CAMPAIGN').then(() => {
          this.saveTemplate();
        });
      } else {
        this.createEmailTemplate().then(() => {
          this.saveTemplate();
        });
      }
    },
  },
});
</script>
